import { io } from "socket.io-client";
import { API_BASE_URL } from "../utils/env";

const socketSetup = io(`${API_BASE_URL}`, {
    withCredentials: true,
    transports: ["polling", "websocket"],
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
});

export default socketSetup;